<template>
    <div class="d-flex justify-center">
        <div class="s-skeleton-form">
            <div class="s-skeleton-form__header">
                <h1 class="app-private-title-dark text-center">
                    {{title}}
                </h1>
            </div>
            <div class="s-skeleton-form__body">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        title: String
    }
}
</script>